// extracted by mini-css-extract-plugin
export var progressBar = "_o0-0";
export var progressBarInner = "_o0-1";